export default __webpack_public_path__ + "static/index-title-versions-ko-11b240dda8385cbeb14d06cde81de9aa.png";